<template lang="pug">
div.padding.p-t-0
    report-filter(
        @onOutletChange="applyOutletFilter",
        @onDateChange="applyDateFilter"
    )
        template(slot="title") Purchase Orders
        template(slot="filters")
            div.col-md-3.m-y-sm.pull-right.filter
                select.form-control.c-select(
                    v-model="status"
                )
                    option(:value="null") Filter Status
                    option(value="0") Opened
                    option(value="1") Ordered
                    option(value="2") Received

    div.row
        div.col-xs-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="order_date" slot-scope="props")
                        span {{ formattedDate(props.row.order_date, 'DD-MM-YYYY') }}
                    
                    template(slot="status" slot-scope="props")
                        span.label.blue-grey(v-if="props.row.status == 0") Open
                        span.label.yellow(v-if="props.row.status == 1") Ordered
                        span.label.green(v-if="props.row.status == 2") Received

                    template(slot="delivery_date" slot-scope="props")
                        span {{ formattedDate(props.row.delivery_date, 'DD-MM-YYYY') }}
</template>

<script>
import { purchaseOrderEvent } from './purchase-order-event-bus';
const exportUrl = 'purchase_order.export';

export default {
    data() {
        return {
            status: null,
            tableName: 'VUETABLE_PURCHASE_ORDER',
            columns: [
                'order_no',
                'outlet',
                'supplier',
                'order_date',
                'delivery_date',
                'order_stocks',
                'status',
            ],
            options: {
                headings: {
                    outlet_id: 'Outlet',
                    supplier_id: 'Supplier',
                },
                permission: {
                    create: () => this.permission.SAVE_PURCHASE_ORDER,
                    delete: () => this.permission.DELETE_PURCHASE_ORDER,
                },
                checkbox: {
                    delete_title: 'Delete PO',
                    api_delete: Laroute.route('purchase_order.delete'),
                },
                checkboxDisableCallback(row) {
                    return row.status == 2;
                },
                columnsClasses: {
                    order_stocks: 'text-center',
                },
                orderBy: {
                    column: 'order_no',
                    ascending: false,
                },
                create_btn: {
                    title: 'New Purchase Order',
                    action: () => {
                        this.$router.push(`/create`);
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.$router.push(`/${row.id}`);
                },
                customFilters: ['outlet_id', 'since', 'until', 'status'],
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                },
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('purchase_order.index');
        },
    },

    watch: {
        status(newValue) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'status',
                value: newValue,
            });
        },
    },

    mounted() {
        purchaseOrderEvent.$on('purchase-order-updated', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        applyOutletFilter(outlet) {
            this.$refs.datatable.applyOutletFilter(outlet);
        },

        applyDateFilter(date) {
            this.$refs.datatable.applyDateFilter(date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-list.vue